const TransactionStatusBadge = ({ status }: { status: string }) => {

    const getTransactionColorAndName = (status: string) => {
        switch (status) {
            case 'success':
                return {
                    color: '#D1FAE5',
                    name: 'success',
                    text: '#065F46',
                }
            case 'failed':
                return {
                    color: '#FE4D97',
                    name: 'failed',
                    text: '#fff',
                }
            default:
                return {
                    color: '#FEF3C7',
                    name: 'pending',
                    text: '#92400E',
                }
        }
    }

    return (
        <span style={{ backgroundColor: getTransactionColorAndName(status).color, color: getTransactionColorAndName(status).text }} className="rounded-full py-2 px-3 text-xs text-white">{status}</span>
    )
}

export default TransactionStatusBadge;